import { dontSemicolons } from 'lib'

export const rulesFieldNameTag = {
	required: {
		value: true,
		message: 'This field is required'
	},
	pattern: {
		value: dontSemicolons,
		message: 'Tag names cannot include semicolons.'
	}
}
